import { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import MultipleTaskSearchStore from './store';

let keyIndex = 0;

const MultipleTaskSearchItem = ({ item, isFullScreenModal }) => {
  const [autoScroll, setAutoScroll] = useState(true);
  const refScroll = useRef(null);

  const mouseenter = () => {
    setAutoScroll(false);
  };

  const mouseleave = () => {
    setAutoScroll(true);
  };

  useEffect(() => {
    const el = refScroll?.current;
    el?.addEventListener('mouseenter', mouseenter);
    el?.addEventListener('mouseleave', mouseleave);

    return () => {
      el?.removeEventListener('mouseenter', mouseenter);
      el?.removeEventListener('mouseleave', mouseleave);
    };
  }, [refScroll?.current]);

  useEffect(() => {
    keyIndex++;
    if (!autoScroll) {
      return;
    }
    const el = refScroll?.current;
    el?.scrollTo({
      left: 0,
      top: el.scrollHeight,
      behavior: 'smooth',
    });
  }, [item]);

  useEffect(() => {
    // 非全屏模式下，更新全屏数据
    if (!isFullScreenModal) {
      if (
        MultipleTaskSearchStore?.currentFullScreenData?.buTaskId ===
        item?.buTaskId
      ) {
        MultipleTaskSearchStore.setFullScreenData(item);
      }
    }
  }, [isFullScreenModal, item]);

  const handleClickImg = () => {
    // 非全屏模式下，点击图片，设置全屏模式
    if (!isFullScreenModal) {
      MultipleTaskSearchStore.setFullScreenData(item);
    }
  };

  const { buResult, actions = [], imageData, buTaskId } = item;
  return (
    <div
      className={[
        isFullScreenModal
          ? 'py-4px'
          : 'pl-15px pr-4px pt-20px pb-24px mt-16px bg-[#F5F5F5] rounded-8px',
      ]}
    >
      <div
        className={[
          isFullScreenModal
            ? 'text-22px font-bold-600 pr-30px leading-31px'
            : 'break-all text-14px text-black leading-20px',
        ]}
      >
        我正{buResult.action === 'add_to_cart' ? '将商品' : '搜索'}
        <span className="font-bold-600 mx-8px">
          {buResult?.result?.content}
        </span>
        {buResult.action === 'add_to_cart' ? '加入购物车' : '的相关内容'}
      </div>
      <div
        className={[
          'text-14px text-black leading-20px',
          isFullScreenModal
            ? 'mt-20px flex-col'
            : 'mt-16px flex items-start h-112px',
        ]}
      >
        <div
          className={[
            'border-1px border-black border-opacity-10  overflow-hidden relative',
            isFullScreenModal ? 'w-full rounded-12px' : 'w-199px h-full rounded-8px',
          ]}
          onClick={handleClickImg}
        >
          <div className="size-full absolute left-0 top-0 border-flash pointer-events-none">
            {imageData?.position?.x && imageData?.position?.y ? (
              <img
                className="absolute"
                src="https://p1.ssl.qhimg.com/t110b9a930157fe0d68c5ea1c10.gif"
                style={{
                  left: imageData?.position?.x,
                  top: imageData?.position?.y,
                  width: '8%',
                }}
              />
            ) : null}
          </div>
          <img
            className="display-block max-w-full max-h-full"
            src={imageData?.url}
          />
          {!isFullScreenModal && !!imageData?.url ? (
            <div className="absolute bottom-8px right-7px size-20px bg-white rounded-4px flex items-center justify-center hover:bg-[#f5f5f5] cursor-pointer">
              <SVGPureIcon name="icon_fullscreen" className="size-20px" />
            </div>
          ) : null}
        </div>
        <div
          className={[
            'flex-1 h-full multiple-task-search-content',
            isFullScreenModal ? 'mt-20px isFullScreenModal' : 'ml-17px',
          ]}
        >
          <div
            className={[
              'overflow-y-scroll scrollbar',
              isFullScreenModal ? 'h-84px' : ' h-full',
            ]}
            ref={refScroll}
          >
            {actions?.length > 0 &&
              actions.map((action, index) => {
                const { result = {}, action: actionType } = action;
                const {
                  desc = '',
                  desc2 = '',
                  content = '',
                  url = '',
                  like_status = 0,
                } = result || {};

                let icon = 'icon_enter';
                let color = 'text-[#000000]';
                if (actionType === 'collecting_info') {
                  icon = 'icon_collect';
                  color = 'text-[#FF7307]';
                } else if (like_status === 1) {
                  icon = 'mcp_tool_like';
                  color = 'text-[#FF7307]';
                } else if (like_status === 2) {
                  icon = 'mcp_tool_notice';
                  color = 'text-[#FF7307]';
                }
                return (
                  <div
                    key={index}
                    className={[
                      'flex items-start mr-15px mt-8px text-14px text-black leading-20px break-all',
                      isFullScreenModal ? 'mt-12px first:mt-0px' : 'mt-8px',
                    ]}
                  >
                    <SVGPureIcon
                      name={icon}
                      className={`size-16px min-w-16px mt-2px mr-9px ${color}`}
                    />

                    <div className="flex-1 leading-20px text-14px text-black">
                      <span>
                        {like_status === 0
                          ? desc
                          : like_status === 1 || like_status === 2
                            ? '我注意到'
                            : ''}
                      </span>
                      {url ? (
                        <a
                          className="!text-black !text-opacity-50 mx-5px !hover:underline"
                          href={url}
                          target="_blank"
                          rel="noopener"
                        >
                          {content}
                        </a>
                      ) : (
                        <span className="text-black text-opacity-50 mx-5px">
                          {content}
                        </span>
                      )}
                      {like_status === 0
                        ? desc2
                        : like_status === 1
                          ? '的点赞收藏评论数量较高，将对其着重关注'
                          : like_status === 2
                            ? '的点赞量较低，将不作为参考'
                            : ''}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(MultipleTaskSearchItem);
